import { GetServerSidePropsContext } from "next";
import { SWRConfig } from "swr";

import Bugsnag from "@bugsnag/js";

import CollectionPageContainer from "components/CollectionPageLayout";
import { collectionLayoutData } from "components/CollectionPageLayout/collectionLayoutData";
import CollectionPageDiscussions from "components/CollectionPageLayout/CollectionPageDiscussions";
import { collectionDiscussionsUrl } from "components/CollectionPageLayout/CollectionPageDiscussions/CollectionPageDiscussionsList";
import { discussionUrl as getDiscussionUrl } from "components/DiscussionModal";
import type { NextPageWithLayout } from "pages/_app";
import { baseFetcher } from "utils/baseFetcher";
import { isSsr } from "utils/isSsr";

const CollectionDiscussionsPage: NextPageWithLayout = () => {
  return <CollectionPageDiscussions />;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  try {
    const slug = context.params?.slug as string;
    const discussionId = context.query.discussion as string;

    const discussionsUrl = collectionDiscussionsUrl(slug, 1);
    const discussionUrl = getDiscussionUrl(discussionId);

    const [{ collection, collectionLayoutFallback }, discussions, discussion] =
      await Promise.all([
        collectionLayoutData(slug, context),
        isSsr(context)
          ? baseFetcher(discussionsUrl, context)
          : Promise.resolve({}),
        isSsr(context) && discussionId
          ? baseFetcher(discussionUrl, context)
          : Promise.resolve({}),
      ]);

    if (!collection || collection.errors?.length) return { notFound: true };

    return {
      props: {
        slug,
        collection,
        fallback: {
          ...collectionLayoutFallback,
          [`$inf$${discussionsUrl}`]: [discussions],
          [discussionUrl]: discussion,
        },
      },
    };
  } catch (error: any) {
    console.error(
      "[slug].tsx ~ getServerSideProps collection discussions Page ~ error",
      error
    );
    Bugsnag.notify(error);
    return { notFound: true };
  }
}

CollectionDiscussionsPage.getLayout = (page, { pageProps }) => {
  const { fallback } = pageProps;

  return (
    <SWRConfig value={{ fallback }}>
      <CollectionPageContainer {...pageProps}>{page}</CollectionPageContainer>
    </SWRConfig>
  );
};

export default CollectionDiscussionsPage;
